import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchAccounts = () => api.get('/account/search').then((res) => res.data);

export default function useAccounts() {
  return useQuery('accounts', fetchAccounts);
}